export default {
  methods: {
    getMaterialName(material) {
      if (!material) return '';

      const locale = this.$i18n.locale || 'en';

      const localeMap = {
        'de': 'name_de',
        'fr': 'name_fr',
        'es': 'name_es',
        'tu': 'name_tu'
      };

      if (locale === 'en' || !localeMap[locale]) {
        return material.name || '';
      }

      const localeProperty = localeMap[locale];
      return material[localeProperty] || material.name || '';
    },
  },
};

